<ion-content class="conference-page-content theme-{{userService.theme}}">
  <ion-header>
    <app-header [backRoute]="['/home']"></app-header>
  </ion-header>
  <div class="conference-page">

    <div class="title" [@enter] *ngIf="false">
      <div class="text my-color-blue">{{ 'Conference' | translate }}</div>
    </div>
<!--    <ion-button (click)="pageLayout = pageLayout === 'dockLeft' ? 'dockBottom' : 'dockLeft' ">Switch</ion-button>-->

    <div class="conference-wrap {{pageLayout}}" [ngClass]="{'in-person': isInPerson}">
      <div class="wrapper-left wrapper-speaker">
        <div class="side-container">
          <div class="panel-container panel-speaker">
            <div class="body" [ngStyle]="{'background-image': 'url('+userService.companyLogo+')'}"
                 id="speakerVideo" #speakerVideo></div>
            <div class="header" *ngIf="speakerVideoType === 'speaker'">{{ 'Speaker' | translate }}</div>
          </div>
        </div>
      </div>

      <div class="wrapper-right" id="main" #main>
        <app-interaction
          [interaction]="interaction"
          [isResults]="isResultsActive"
          [isWordCloudReady]="isWordCloudReady"
          [ngClass]="{'margin-bottom': isInteractionActive}"
        ></app-interaction>
        <app-zoom
          *ngIf="!isInPerson && isZoomEnabled"
          [resize]="pageLayout + (isInteractionActive ? ' hiddenForced' : '')"
          [credentials]="zoomCredentials"
          [isInteractionActive]="isInteractionActive"
          [speakerVideoElement]="speakerVideoRef.nativeElement"
          [speakerVideoType]="speakerVideoType"
        ></app-zoom>
        <app-emojis *ngIf="mainRef && !isInPerson && isZoomEnabled"
                    [container]="mainRef.nativeElement"
                    [emoji]="emoji"
                    (onSubmit)="onEmojiSend($event)"
        ></app-emojis>
      </div>

      <div class="wrapper-left" *ngIf="!isInPerson && isTalkJSActive && task" [ngClass]="{'wrapper-chat': isZoomEnabled}">
        <div id="chat"></div>
        <app-talkjs *ngIf="isTalkJSActive && task" [taskId]="task.id"></app-talkjs>
      </div>
      <div class="wrapper-right" *ngIf="!isInPerson && isSocialActive && urlSocial">
        <div class="meeting-pulse" *ngIf="isSocialActive && urlSocial">
          <iframe class="panel-container" [src]="urlSocial | safeUrl" style="border:none;" allow="encrypted-media" credentialless></iframe>
        </div>
      </div>
    </div>
  </div>
</ion-content>
